import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ReservationCreateComponent } from './reservation-create/reservation-create.component';
import { ReservationSearchComponent } from './reservation-search/reservation-search.component';
import { ReservationUpdateComponent } from './reservation-update/reservation-update.component';
import { ReservationCalendarComponent } from './reservation-calendar/reservation-calendar.component';

@NgModule({
    imports: [FormsModule, CommonModule, RouterModule],
    declarations: [
        ReservationCreateComponent,
        ReservationSearchComponent,
        ReservationUpdateComponent,
        ReservationCalendarComponent
    ],
    providers: [],
    exports: [
        ReservationCreateComponent,
        ReservationSearchComponent,
        ReservationUpdateComponent,
        ReservationCalendarComponent
    ]
})
export class ReservationSharedModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation.shared.module.ts